<template>
  <v-app>
    <cabecera/>
    <v-main style="background-color: #6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>
        <v-row justify="center"  >
          <v-col  cols="12" lg="8" md="8" sm="12">
            <v-card color="#F2E7D5" elevation="10">
              <v-card-title style="color: #393E46;">
               <h1 class="text-h4 font-weight-bold">Mis QRs</h1>
              </v-card-title>
              <v-card-subtitle  style="color: #393E46;">Encuentre sus Qrs para las fiestas que esta invitado</v-card-subtitle>
              <v-card-text>


                    <v-row>
                      <v-col cols="12" lg="6" md="6" sm="12" v-for="ticket in qrsact" :key="ticket.id">
                        <v-card v-if="ticket.ingreso === false" color="#393E46"  elevation="10">
                          <v-card-title  justify="center" style="color: #F7F7F7" ><h2 >{{ticket.negocio}}</h2></v-card-title>
                          <v-card-subtitle style="color: #F7F7F7"  justify="center" ><h3 >{{ticket.nombreActo}} - Fecha: {{ticket.fechaActo}}</h3></v-card-subtitle>
                          <v-card-text style="color: #F7F7F7" >
                            <v-row >
                              <v-col cols="12" lg="6" md="6" sm="6">
                                <p>{{ticket.nombre}}</p>
                                <p>{{ticket.tipoLista}}</p>
                                <p><v-btn color="#F2E7D5" style="color: #393E46"   @click="verentrada(ticket)"><v-icon left>
                                  fas fa-qrcode
                                </v-icon>Ver QR</v-btn></p>
                                <p><v-btn color="#F2E7D5" style="color: #393E46" @click="verwallet(ticket)"><v-icon left>
                                  fas fa-wallet
                                </v-icon>Bajar a Wallet</v-btn></p>
                              </v-col>
                              <v-col cols="12" lg="6" md="6" sm="6">
                                <vue-qr :text="ticket.codigoUnico" :size="100" :logoCornerRadius="8"   :logoMargin="6"  :logoScale="0.2" />
                              </v-col>

                            </v-row>

                          </v-card-text>
                        </v-card>
                        <v-card v-else color="red" elevation="10">
                          <v-card-title  justify="center" ><h2 >{{ticket.negocio}}</h2></v-card-title>
                          <v-card-subtitle  justify="center" ><h3 >{{ticket.nombreActo}}- Fecha: {{ticket.fechaActo}}</h3></v-card-subtitle>
                          <v-card-text >
                            <v-row>
                              <v-col>
                                <h2 style="color:white;">TICKET USADO</h2>
                              </v-col>
                            </v-row>
                            <v-row >
                              <v-col cols="12" lg="6" md="6" sm="6">
                                <p>{{ticket.nombre}}</p>
                                <p>{{ticket.tipoLista}}</p>
                                <p><v-btn class="primary" @click="verentrada(ticket)"><v-icon left>
                                  fas fa-qrcode
                                </v-icon>Ver QR</v-btn></p>
                                <p><v-btn class="primary" @click="verwallet(ticket)"><v-icon left>
                                  fas fa-wallet
                                </v-icon>Bajar a Wallet</v-btn></p>
                              </v-col>
                              <v-col cols="12" lg="6" md="6" sm="6">
                                <vue-qr :text="ticket.codigoUnico" :size="100"  />
                              </v-col>

                            </v-row>

                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>



              </v-card-text>
            </v-card>

        </v-col>

        </v-row>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>

    </v-main>
    <piepagina/>
  </v-app>
</template>
<script>
import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";
import {mapGetters} from "vuex";
import axios from "axios";
import VueQr from 'vue-qr'
import store from "@/store";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  name: 'misqr',
  title: 'QRs | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    cabecera,
    piepagina,
    VueQr
  },
  data: () => ({
    overlay: false,
    tab: null,
    date1: new Date(),
    qrsact:[],
    qrspas:[]
  }),
  mounted() {
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

              this.getTickets()
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })

    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.getTickets()
    }
  },
  watch:{
    '$store.state.usuario': function (){
      if (this.usuario.id === undefined){
        this.overlay = true
        firebase
            .auth()
            .onAuthStateChanged(user => {
              if(user){
                this.overlay = false
                this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

                this.getTickets()
              }else{
                this.overlay = false
                this.$router.push({ path: '/' });
              }
            })

      }else{
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.getTickets()
      }
    }
  },
  methods:{
    getTickets(){
      this.overlay = true
      axios.get("lista/qrs/"+this.usuario.id,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response=>{
            this.overlay = false
            this.qrsact = response.data

          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;
          });
    },
    verwallet(ticket){
      axios
          .get(
         'passkit/'+ticket.codigoUnico,
        {
            responseType: 'arraybuffer',
            headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response=>{
            const reader = new FileReader();
            const out = new Blob([response.data], {
              type: "application/vnd.apple.pkpass",
            });
            reader.onload = function () {
              if (reader.result !== null) {
                window.location.href = reader.result.toString();
              }
            };
            reader.readAsDataURL(out);
          })
          .catch(() => console.log('error occured'))
    },
    verentrada(ticket){
      store.dispatch("fetchQrTicket",ticket)
      this.$router.push({ path: '/qr' });
    },
  },
computed: {
  // map `this.user` to `this.$store.getters.user`
...mapGetters({
    usuario: "usuario"
  })
}
}
</script>